<template>
  

    <div class="grid">
      <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
      <div class="col-12">
        <div class="card">
          <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
                <!--<template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href" v-bind="props.action" @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                </template>-->
                <template #item="{ item, props }">
                     <router-link v-if="item.to" v-slot="{ href, navigate }"  :to="item.to" custom>
                        <a :href="href"   @click="navigate" >
                            <span :class="[item.icon, 'text-color']" ></span>
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link> 
                    <a v-else :href="item.url" :target="item.target" v-bind="props.action">
                    <span class="text-color">{{ item.label }}</span>
                </a>
                </template>
            </Breadcrumb>
  
          <Toast />
          
              <!-- <div class="p-fluid formgrid grid" style="margin-top: 2%;">  
              
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Calendar
                    v-model="from_date"
                    dateFormat="dd-mm-yy"
                    :showIcon="true"
                    :showTime="false"                  
                    hourFormat="12"
                  /><label >From Date</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Calendar
                    v-model="to_date"
                    dateFormat="dd-mm-yy"
                    :showIcon="true"
                    :showTime="false"
                    
                    hourFormat="12"
                  /><label >To Date</label>
                </span>
                
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <InputText 
                    type="text" 
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57" 
                    maxlength="10"
                    v-model="search_mobile" 
                  />
                  <label for="mobile_no">Mobile No.</label>
                </span>
                
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Dropdown id="state" filter v-model="ride_status" :options="ride_status_dropdown" optionLabel="name" :optionValue="name"></Dropdown>
                <label for="Status">Status</label>
                </span>
                
              </div>
  
                
                <div class="field col-12 md:col-2" v-if="showFirstFilter">
                <span class="p-float-label">
                  <InputText type="text" v-model="search_name" /><label for="mobile_no">Name</label>
                </span>
                
              </div>
              <div class="field col-12 md:col-2" v-if="showFirstFilter">
                <span class="p-float-label">
                  <InputText type="text" v-model="search_city" /><label for="mobile_no">City</label>
                </span>
                
              </div>
              <div class="field col-12 md:col-2" v-if="showFirstFilter">
                <span class="p-float-label">
                  <InputText type="text" v-model="search_state" /><label for="mobile_no">State</label>
                </span>
                
              </div>
              <div class="field col-12 md:col-2" v-if="showFirstFilter">
                <span class="p-float-label">
                  <InputText type="text" v-model="search_pincode" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="6" /><label for="mobile_no">Pincode</label>
                </span>
                
              </div>
              <div class="field col-12 md:col-2" v-if="showFirstFilter">
                <span class="p-float-label">
                  <InputText type="text" v-model="vehicle_registrationNumber" /><label for="mobile_no">Vehicle Number</label>
                </span>
                
              </div>
              <div class="field col-12 md:col-2" v-if="user_key && (user_key=='Admin' || user_key=='admin') && showFirstFilter">
                  <span class="p-float-label">
                    <Dropdown v-if="user_key && (user_key=='Admin' || user_key=='admin')" id="state" filter  v-model="client_id_search" :options="client_id_dropdown" optionLabel="name" :optionValue="value" @change="route_list"></Dropdown>
                  <label for="client">Select Client</label>
                </span>
                </div>
  
              <div class="field col-12 md:col-2" v-if="showFirstFilter">
                  <span class="p-float-label">
                    <Dropdown        
                        id="status" filter
                        v-model="routeitem"
                        :options="routeitems"
                        :value="routeitems.value"
                        optionLabel="name"
                        required="true"
                        
                    ></Dropdown>
                  <label for="client">Select Route</label>
                </span>
                </div>
  
  
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Button  
                    icon="pi pi-search" 
                    @click="search(1)"   
                    v-tooltip.bottom="'Search'"
                    style="background-color: #349CE4; border: 1px solid #349CE4;"              
                    />
                    <button v-if="!showFirstFilter" 
                        style=" background-color: #3498db;  color: white; border: none; border-radius: 5px; margin-left: 10px; padding: 10px 20px; font-size: 16px; cursor: pointer; transition: background-color 0.3s; box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);"
                        @click="show_filter()">
                     more
                  </button>
                </span>              
                
              </div>
            </div>    -->
         
            <div style="margin-top: 2%;">
            <ride_gps    
                :vehicle_dropdownItems="vehicle_dropdownItems" 
                :routeitems="routeitems" 
                :client_id_dropdown="client_id_dropdown"
                :user_key="user_key"
                :client_group_ids="client_group_ids"
                >
            </ride_gps>
        </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { FilterMatchMode } from "primevue/api";
  import ProductService from "../service/ProductService";
  import BreadcrumbService from "../service/BreadcrumbService";
  
  import JsonExcel from "vue-json-excel";
  import ride_gps from '../components/ride_gps';
 
  import apis from "@/apis";
  import axios from "axios";
  
  export default {
    data() {
      return {      
        showFirstFilter: false,
        user_key:"",
        client_id_dropdown: [],
        client_id_search:'',
  
        routeitem:'',
        routeitems:[],
  
        page_no:1,
        isLoading: false,
        search_mobile:'',
        search_name:'',
        search_city:'',
        search_state:'',
        search_pincode:'',
        vehicle_registrationNumber:'',
        from_date:'',
        to_date:'',
        isLoadingModel: false,
        loading: false,
        fullPage: true,
        file_attachment: "",
        
        dropdownItems: [
          { name: "Active", value: "Active" },
          { name: "InActive", value: "InActive" },
          { name: "Deleted", value: "Deleted" },
        ],
        products: null,
        productDialog: false,
        deleteProductDialog: false,
        deleteProductsDialog: false,
        lazyParams: {},
        product: {},
        selectedProducts: null,
        filters: {},
        offset: 1,
        selectstatus: { name: "", value: "" },
        // selectstatus2: { name: "Motivational", value: "Motivational" },
        limit: 10,
        columns: [],
        head: [
          "Data Usages",
          "Network Connectivity",
          "Students",
          "Teachers",
          "Student Registration",
          "News Master",
          "Government Panel",
          "Feedback Master",
          "User Queries",
          "Schemes Master",
          "Notice Master",
          "Subject Master",
          "Teacher Schedule Master",
          "Teacher Schedule DE Master",
          "Query Types Master",
          "Sub Query Types Master",
          "Admin Users",
          "Application Roles",
          "Departments",
          "Cast Master",
          "Year Master",
          "District Master",
          "Student Attendance",
          "Student Document",
          "Teachers",
          "Radical ids",
          "Subject Topics",
          "Query Comments",
          "Student Submit Answers",
          "Mock Tests",
          "Mock Test Papers",
          "Mock Test Results",
          "Video",
          "Syllabus",
          "Course",
        ],
        pageno: 1,
        submitted: false,
        totalRecords: 0,
        ride_status:'',
        // ride_status_dropdown: [{ name: "Read", value: "1" },
        //                        {name: "UnRead", value: "0"},
                               
        //                       ],
        ride_status_dropdown: [{ name: "Complete", value: "Complete" },
                               {name: "Active", value: "Active"},
                               {name: "InActive", value: "InActive"}],
        id: "",
        statuses: [
          { label: "INSTOCK", value: "instock" },
          { label: "LOWSTOCK", value: "lowstock" },
          { label: "OUTOFSTOCK", value: "outofstock" },
        ],
        BreadcrumbService : null,
        breadcrumbHome: {},
        breadcrumbItems: [],
      };
    },
    productService: null,
    async created() {
      this.productService = new ProductService();
      this.initFilters();
      this.get_client_list();
      this.route_list();
      this.showFirstFilter = false;
      this.user_key=localStorage.getItem("user_key");
  
      this.BreadcrumbService = new BreadcrumbService();
      let Breadcrum_data = this.BreadcrumbService.ridemaster()
      this.breadcrumbHome=Breadcrum_data.home;
      this.breadcrumbItems=Breadcrum_data.items;
    },
    async mounted() {
      // this.productService.getProducts().then(data => this.products = data);
      this.id = this.$route.params.id;
  
      this.lazyParams = {
        first: 0,
        rows: this.limit,
        sortField: null,
        sortOrder: null,
        filters: this.filters,
      };
      if (this.totalRecords == 0) {
        await this.get_count();
      }
      await this.get_list();
      //alert(this.id);
    },
    watch: {
      async $route() {
        this.products = [];
        this.columns = [];
        this.totalRecords = 0;
        this.id = this.$route.params.id;
        if (this.id) {
          await this.get_count();
          this.get_list();
        }
      },
    },
    methods: {
      show_filter() {
        this.showFirstFilter = true;
      },
     async view_ride_details(data)
      {
        await localStorage.setItem('ridedetails',JSON.stringify(data));
        this.$router.push({name:"RideDetails"});
      },
      search(count)
        { 
          if (count==2) 
          {
              this.from_date='';
              this.to_date='';
              this.search_mobile='';
              this.search_name='';
              this.search_city='';
              this.search_state='';
              this.search_pincode='';
              this.vehicle_registrationNumber='';
              this.ride_status='';
              this.client_id_search='';
              this.routeitem='';
              this.showFirstFilter=false;
              this.route_list();
  
          }
          if(this.search_mobile!='' && this.search_mobile.length!=10)
          {
            this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Valid Mobile Number",
            life: 3000,
          });
          return false;
          }
          this.page_no=1;
          this.get_list();
          this.get_count();
      },
      //a simple date formatting function
      dateFormat(inputDate) {
          var postdate=inputDate;
          if(inputDate)
          {
              inputDate=new Date(inputDate);
              if(inputDate.toString()=='NaN-NaN-NaN')
              {
                  return postdate;
                  
              }
              else
              {
                  let date = ("0" + inputDate.getDate()).slice(-2);
  
          // current month
                  let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
  
                  // current year
                  let year = inputDate.getFullYear();
                  if(date.toString()=='aN')
                  {
                    return postdate;
                  }
                  else
                  {
                    return date+"-"+month+"-"+year;
                  }
              }
          }
          else {
             return "";
          }
      },
      dateFormatYMD(inputDate) {
          var postdate=inputDate;
          if(inputDate)
          {
              inputDate=new Date(inputDate);
              if(inputDate.toString()=='NaN-NaN-NaN')
              {
                  return postdate;
                  
              }
              else
              {
                  let date = ("0" + inputDate.getDate()).slice(-2);
  
          // current month
                  let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
  
                  // current year
                  let year = inputDate.getFullYear();
                  if(date.toString()=='aN')
                  {
                    return postdate;
                  }
                  else
                  {
                    return year+"-"+month+"-"+date;
                  }
              }
          }
          else {
             return "";
          }
      },
      handleFileUpload() {
        this.file_attachment = this.$refs.file_attachment.files[0];
  
        //alert(this.$refs.file_attachment.files[0].name);
      },
      async onPage(event) {
        this.lazyParams = event;
        this.page_no = event.page + 1;
        this.limit = event.rows;
        // console.log(event);
      //  await this.get_count();
        if (this.totalRecords > 0) {
          this.get_list();
        }
      },
      route_list()
      {     this.routeitems=[];
        var client_id=this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id");
        var data = {
            
            count: false,
            client_id: client_id
    
          };
          this.loading = true;
          var promise = apis.group_list(data, this.id);
          promise.then((response) => {
            this.loading = false;
            if (response.data.data.length > 0) {
              
            response.data.data
              .filter(item => item.name)
              .map(item => this.routeitems.push({ name: item.name, value: item._id }));
           
            }
          });
      },
      get_client_list()
      { 
        var data = { count: false};
        var promise = apis.getclientist(data);
          promise.then((response) => {
            if(response.data.data){
            response.data.data
              .filter(item => item.client_name)
              .map(item => this.client_id_dropdown.push({ name: item.client_name, value: item._id }));
            }
          });
      },
      get_count: function () {
        var data = {
          id: localStorage.getItem("id"),
          count: true,
          mobile_number:this.search_mobile,
          status:this.ride_status.value,
          from_date:this.dateFormatYMD(this.from_date),
          to_date:this.dateFormatYMD(this.to_date),
          client_id:this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id"),
  
          name:this.search_name,
          city:this.search_city,
          Region:this.search_state,
          pincode:this.search_pincode,
          vehicle_registrationNumber:this.vehicle_registrationNumber,
          group_id:this.routeitem.value
        };
        this.loading = true;
        var promise = apis.rideMaster(data, this.id);
        promise.then((response) => {
          this.loading = false;
          console.log(response);
          this.totalRecords = response.data.data;
          //alert(this.totalRecords);
        });
  
        console.log(data);
      },
      get_list: function () {
        var data = {
          limit: this.limit,
          page_no: this.page_no,
          count: false,
          status:this.ride_status.value,
          mobile_number:this.search_mobile,
          from_date:this.dateFormatYMD(this.from_date),
          to_date:this.dateFormatYMD(this.to_date),
          client_id:this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id"),
  
          name:this.search_name,
          city:this.search_city,
          Region:this.search_state,
          pincode:this.search_pincode,
          vehicle_registrationNumber:this.vehicle_registrationNumber,
          group_id:this.routeitem.value
        };
        this.loading = true;
        var promise = apis.rideMaster(data, this.id);
        promise.then((response) => {
          this.loading = false;
          console.log(response);
          this.products = response.data.data;
          console.log(this.products[0]);
          if (this.columns.length == 0) {
            if (this.products.length > 0) {
              this.columns = Object.keys(this.products[0]);
            }
          }
        });
  
        console.log(data);
      },
      formatCurrency(value) {
        if (value)
          return value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
        return;
      },
      openNew() {
        this.product = {};
        this.submitted = false;
        this.productDialog = true;
      },
      hideDialog() {
        this.productDialog = false;
        this.submitted = false;
      },
      async adduser() {
        this.submitted = true;
        if (!this.selectstatus.value) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Select Status",
            life: 3000,
          });
          return false;
        }
        if (!this.product.firsT_NAME) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter First Name",
            life: 3000,
          });
          return false;
        }
        if (!this.product.middeL_NAME) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Middle Name",
            life: 3000,
          });
          return false;
        }
        if (!this.product.surname) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter LastName",
            life: 3000,
          });
          return false;
        }
         if (!this.product.aadhaR_CARD) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Adhar No",
            life: 3000,
          });
          return false;
        }
        
        if (!this.product.state) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter State",
            life: 3000,
          });
          return false;
        }
        if (!this.product.disrtict) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter District",
            life: 3000,
          });
          return false;
        }
         if (!this.product.taluka) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Taluka",
            life: 3000,
          });
          return false;
        }
        if (!this.product.citY_VILLAGE) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter city/village",
            life: 3000,
          });
          return false;
        }
        if (!this.product.pincode) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Pincode",
            life: 3000,
          });
          return false;
        }
        if (!this.product.address) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter address",
            life: 3000,
          });
          return false;
        }
        if (!this.product.mobile) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter mobile",
            life: 3000,
          });
          return false;
        }
        if (!this.product.email) {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter email",
            life: 3000,
          });
          return false;
        }
  
        //edit
        if (this.product.admiN_ID) {
          var data = {
            Admin_id: this.product.admiN_ID,
            firsT_NAME: this.product.firsT_NAME,
            middeL_NAME: this.product.middeL_NAME,
            surname: this.product.surname,
            address: this.product.address,
            state: this.product.state,
            disrtict: this.product.disrtict,
            taluka: this.product.taluka,
            citY_VILLAGE: this.product.citY_VILLAGE,
            mobile: parseInt(this.product.mobile),
            email: this.product.email,
            pincode: parseInt(this.product.pincode),
            aadhaR_CARD: parseInt(this.product.aadhaR_CARD),
            status: this.selectstatus.value,
            createD_BY: localStorage.getItem("full_name"),
            client_id:this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id")
          };
          this.isLoadingModel = true;
          var promise = apis.editusermaster(data);
          promise
            .then((responseapi) => {
              this.$swal(responseapi.data.message);
              this.isLoadingModel = false;
              this.productDialog = false;
              this.get_list();
              this.get_count();
            })
            .catch((error) => {
              //console.log(error);
              this.isLoadingModel = false;
              this.productDialog = false;
  
              this.$swal.fire(error.response.data);
              this.get_list();
              this.get_count();
            });
        }
        //add-----------------------------------------------------------------------------------------------------------------
        else {
          var data1 = {
            firsT_NAME: this.product.firsT_NAME,
            middeL_NAME: this.product.middeL_NAME,
            surname: this.product.surname,
            address: this.product.address,
            state: this.product.state,
            disrtict: this.product.disrtict,
            taluka: this.product.taluka,
            citY_VILLAGE: this.product.citY_VILLAGE,
            mobile: parseInt(this.product.mobile),
            email: this.product.email,
            pincode: parseInt(this.product.pincode),
            aadhaR_CARD: parseInt(this.product.aadhaR_CARD),
            status: this.selectstatus.value,
            createD_BY: localStorage.getItem("full_name"),
            client_id:this.client_id_search.value?this.client_id_search.value:localStorage.getItem("client_id")
          };
          this.isLoadingModel = true;
          var promises = apis.addusermaster(data1);
          promises
            .then((response) => {
              this.isLoadingModel = false;
              this.productDialog = false;
              this.$swal(response.data.message);
              this.get_list();
              this.get_count();
            })
            .catch((error) => {
              //console.log(error);
              this.isLoadingModel = false;
              this.productDialog = false;
  
              this.$swal.fire(error.response.data);
              this.get_list();
              this.get_count();
            });
        }
  
        this.selectstatus = { name: "", value: "" };
        //  this.selectstatus2={name:"",value:""}
      },
      saveProduct() {
        this.submitted = true;
        if (this.product.name.trim()) {
          if (this.product.id) {
            this.product.inventoryStatus = this.product.inventoryStatus.value
              ? this.product.inventoryStatus.value
              : this.product.inventoryStatus;
            this.products[this.findIndexById(this.product.id)] = this.product;
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "Product Updated",
              life: 3000,
            });
          } else {
            this.product.id = this.createId();
            this.product.code = this.createId();
            this.product.image = "product-placeholder.svg";
            this.product.inventoryStatus = this.product.inventoryStatus
              ? this.product.inventoryStatus.value
              : "INSTOCK";
            this.products.push(this.product);
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "Product Created",
              life: 3000,
            });
          }
          this.productDialog = false;
          this.product = {};
        }
      },
      editProduct(product) {
        this.file_attachment = "";
        this.product = { ...product };
        this.productDialog = true;
        this.selectstatus.value = this.product.status;
        this.selectstatus.name = this.product.status;
      },
      confirmDeleteProduct(product) {
        this.product = product;
        this.deleteProductDialog = true;
      },
      deleteProduct() {
        this.products = this.products.filter((val) => val.id !== this.product.id);
        this.deleteProductDialog = false;
        this.product = {};
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Product Deleted",
          life: 3000,
        });
      },
  
      deleteuser() {
        if (this.product._id) {
          var data = {
            _id: this.product._id,
          };
          this.isLoadingModel = true;
          var promise = apis.deleteusermaster(data);
          promise.then((responseapi) => {
            this.isLoadingModel = false;
            if (responseapi.data.status == true) {
              // this.hideDialog1();
              this.deleteProductDialog = false;
              this.$swal(responseapi.data.message);
              this.get_list();
              this.get_count();
            } else {
              this.$swal("error to Delete Video");
            }
          });
        }
      },
      findIndexById(id) {
        let index = -1;
        for (let i = 0; i < this.products.length; i++) {
          if (this.products[i].id === id) {
            index = i;
            break;
          }
        }
        return index;
      },
      createId() {
        let id = "";
        var chars =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 5; i++) {
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      },
      
    async  exportCSV() {
        this.limit=this.totalRecords;
        this.get_list();
       await this.$refs.dt.exportCSV();
      },
      confirmDeleteSelected() {
        this.deleteProductsDialog = true;
      },
      deleteSelectedProducts() {
        this.products = this.products.filter(
          (val) => !this.selectedProducts.includes(val)
        );
        this.deleteProductsDialog = false;
        this.selectedProducts = null;
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Products Deleted",
          life: 3000,
        });
      },
      initFilters() {
        this.filters = {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        };
      },
    },
    components: {downloadExcel: JsonExcel,ride_gps,},
  };
  </script>
  
  <style scoped lang="scss">
  @import "../assets/demo/badges.scss";
  </style>
  